// extracted by mini-css-extract-plugin
export default {"smallImage":"apTU7","largeImage":"B0C8G","oosOverlay":"UsjgH","oosOverlayLine":"DNSG7","facetThumbnailLink":"PSk4r","isCarousel":"vjLDe","facetThumbnailLinkDisabled":"j93mc"};